module.exports = __webpack_public_path__ + "assets/img/b4b4f96f354671c29ee3834c239d1567.png";